export class User {
    public idUser: number | undefined;
    public login = "";
    public email = "";
    public title = "";
    public usageName = "";
    public zipcode = "";
    public phoneCode = "";
    public phone = "";
    public language: string | undefined;
    public profile: {
        id: number;
        parameterId: number;
        name: string;
        indexUrl: string;
        functionalities: {
            code: string;
            description: string;
        }[];
    } | undefined;
    public roles: string[] | undefined;
    public creationDate: number | undefined;
    public lastConnection: number | undefined;
    public numberOfConnection: number | undefined;
    public profileEndDate: string | number = 0;
    public subscriptionEndDateDelay: string | undefined;
    public deletionDate: string | undefined;
    public deletionReason: string | undefined;
    public locked: boolean | undefined;
    public activated: boolean | undefined;
    public newPassword: string | undefined;
    public frequency: string | undefined;
    public paypalId: string | undefined;
    public subscriptionId: string | undefined;
    public regular: boolean | undefined;
    public active: boolean | undefined;
    public subscriptions: any[] | undefined;
    public userDetails: {
        serviceInfo: boolean;
        newsletter: boolean;
        partners: boolean;
        reasons: any[];
        comment: string | undefined;
    } | undefined;
    public parameter: {
        modeAutoImport: string | undefined;
    } | undefined;
    public budgetInsightInfos: string | undefined;
    public comment: string | undefined;
    public agreedCgu: boolean | undefined;

}